import { activeLanguage } from '../activeLanguage';
// import { ProfiLoungeHotspot } from "../components/profi-lounge-hotspot";
import { ArrowAlignType, LabelStyle, LabelText, TooltipType } from "../components/ui/hotspot-flag"
import { BuildingType } from "./buildings"

export type HotspotConfig = {
    coordinates: {x: number, y: number},
    building: BuildingType,
    link?: string;
    type?: TooltipType;
    comingSoon?: boolean;
    labelText?: LabelText;
    labelStyle?: LabelStyle;
    arrowAlign?: ArrowAlignType;
    subBuildings?: boolean;
    showSector?: boolean;
    component?: React.FunctionComponent<any>;
    showNewFlag?: boolean;
    isBigFlag?: boolean;
}

export type HotspotList = HotspotConfig[];

export const cityHotspots: HotspotList = [
    {
        coordinates: { x: 200, y: 900 },
        building: BuildingType.HOUSE,
    },
    {
        coordinates: { x: 240, y: 265 },
        building: BuildingType.DATA_CENTER,
        subBuildings: true,
        showNewFlag: true,
    },
    {
        coordinates: { x: 366, y: 600 },
        building: BuildingType.HOSPITAL,
    },
    {
        coordinates: { x: 629, y: 420 },
        building: BuildingType.ADMINISTRATION,
    },
    {
        coordinates: { x: 660, y: 835 },
        building: BuildingType.HOTEL,
        showNewFlag: false,
    },
    {
        coordinates: { x: 729, y: 580 },
        building: BuildingType.SCHOOL,
    },
    {
        coordinates: { x: 970, y: 351 },
        building: BuildingType.KSB_QUICKLINKS,
    },
    ...(activeLanguage.locale.language === 'fr'
        ? []
        : [
              {
                  coordinates: { x: 1250, y: 401 },
                  building: BuildingType.SKYSCRAPER,
              },
          ]),
    {
        coordinates: { x: 1236, y: 750 },
        building: BuildingType.APARTMENT,
    },
    {
        coordinates: { x: 1370, y: 125 },
        building: BuildingType.FACTORY,
        subBuildings: true,
    },
    {
        coordinates: { x: 1590, y: 500 },
        building: BuildingType.INDUSTRY,
        subBuildings: true,
    },
];

export const subBuildingRoutes: HotspotConfig[] = [
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.FACTORY_HEATING
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.FACTORY_PROCESSES
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.FACTORY_PRODUCTION
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.FACTORY_SPRINKLER_CENTER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_LAB
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_PRODUCTION
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_TESTCENTER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_WATER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_SPRINKLER_CENTER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.INDUSTRY_HEATING
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.SKYSCRAPER_WATER_UPPER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.SKYSCRAPER_WATER_LOWER
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.DATA_CENTER_COOLING_AIR
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.DATA_CENTER_COOLING_DIRECT
    },
    {
        coordinates: {x: 0, y: 0},
        building: BuildingType.DATA_CENTER_COOLING_LIQUID
    },
]
